import { render, staticRenderFns } from "./topAd.vue?vue&type=template&id=5353c5b8&scoped=true"
import script from "./topAd.vue?vue&type=script&lang=js"
export * from "./topAd.vue?vue&type=script&lang=js"
import style0 from "./topAd.vue?vue&type=style&index=0&id=5353c5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5353c5b8",
  null
  
)

export default component.exports